import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-purchases',
  templateUrl: './purchases.component.html',
  styleUrls: ['./purchases.component.sass']
})
export class PurchasesComponent implements OnInit {
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public tabActive='Compras';
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  constructor(public AngularFireAnalytics:AngularFireAnalytics,public global:GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Compras");
    this.AngularFireAnalytics.logEvent("Compras-Screenview");
   }

  ngOnInit() {
    
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw){
    
  }
}
